module.exports = __webpack_public_path__ + "static/media/mament.d9aafa41.png";